import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { RefundService } from 'src/app/_services/refund.service';
import { RefundRequestComponent } from '../refund-request/refund-request.component';
import { CancelRefundComponent } from '../cancelRefund/cancel-refund/cancel-refund.component';
import { PaymentService } from 'src/app/_services/payment.service';
import { DashboardService } from 'src/app/_services/dashboard.service';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { AuthService } from 'src/app/_services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-comp',
  templateUrl: './dashboard-comp.component.html',
  styleUrls: ['./dashboard-comp.component.css'],
  providers: [DatePipe],
})

export class DashboardCompComponent implements OnInit {
  constructor(public dialog: MatDialog,
    public refundService: RefundService,
    public router: Router,
    public paymentService: PaymentService,
    public authService: AuthService,
    public dashboardService: DashboardService,
    public datePipe: DatePipe) { }

  refundData: [] = [];
  paymentTrans: [] = [];
  paymentReceived: [] = [];
  paymentsPend: [] = [];
  remittedPay: [] = [];
  pendingRemittedPay: [] = [];
  remittedRecieve: any;
  remittedPending: any;
  paymentRecieve: any;
  paymentPending: any;
  isLoading: boolean = false;

  date = new Date();
  firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  lastDay = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);

  @ViewChild('received') received: MatPaginator;
  @ViewChild('pendingRemit') pendingRemit: MatPaginator;
  @ViewChild('remit') remit: MatPaginator;
  @ViewChild('pendingpay') pendingpay: MatPaginator;


  public refundDataSource = new MatTableDataSource(this.refundData);
  public paymentTransDataSource = new MatTableDataSource(this.paymentTrans);
  public receivedDataSource = new MatTableDataSource(this.paymentReceived);
  public pendingRemittedDataSource = new MatTableDataSource(this.pendingRemittedPay);
  public remittedDataSource = new MatTableDataSource(this.remittedPay);
  public pendingPayDataSource = new MatTableDataSource(this.paymentsPend);

  displayedColumnsPayTrans: string[] = ['srNo', 'orderDate', 'trackingNumber', 'loanNumber', 'settleDate', 'cardHolderName', 'borrowerName', 'vendorName', 'settleAmount'];
  displayedColumnsRefund: string[] = ['srNo', 'refundReqOn', 'transRefNo', 'refundAmount', 'refundStatus', 'cancel'];
  displayedColPayRec: string[] = ['srNo', 'orderDate', 'loanNumber', 'settleDate', 'lenderName', 'borrower', 'vendorName', 'settleAmt'];
  displayPendingPayments: string[] = ['srNo', 'orderDate', 'loanNumber', 'settleDate', 'lenderName', 'borrower', 'vendorName', 'settleAmt'];
  displayColPendingRemittance: string[] = ['srNo', 'loanNumber', 'borrower', 'propertyAddress', 'lenderName', 'orderDate', 'remitDate', 'refundAmount', 'settleAmt', 'remitAmount'];
  displayColRemitted: string[] = ['srNo', 'loanNumber', 'borrower', 'propertyAddress', 'lenderName', 'orderDate', 'remitDate', 'refundAmount', 'settleAmt', 'remitAmount'];


  ngOnInit(): void {
    // if (this.authService.getRegistredUserDetails().isActive === false) {
    //   this.router.navigate(['/inactiveAll/inactiveUser']);
    // }
    this.getLastFiveRefunds();
    this.lastFivePayTrans();
    this.recievedPayments();
    this.pendingRemittedPayments();
    this.remittedPayments();
    this.pendingPayments();
    // this.isLoading=false;
  }

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    this.receivedDataSource.paginator = this.received;
    this.pendingRemittedDataSource.paginator = this.pendingRemit;
    this.remittedDataSource.paginator = this.remit;
    this.pendingPayDataSource.paginator = this.pendingpay;
  }

  //get last 5 refunds
  getLastFiveRefunds() {
    this.isLoading = true;
    this.dashboardService.getLastFiveRefunds('').subscribe((response: any) => {
      console.log(response);
      this.refundData = response;
      this.refundDataSource.data = this.refundData;
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.isLoading = false;
    })
  }

  //get refund detail by id
  getRefundDetailsById(refundRequestId: any) {
    this.refundService.getRefundDetailsById(refundRequestId).subscribe((response: any) => {
      console.log(response);
      const dialogRef = this.dialog.open(RefundRequestComponent, {
        width: '700px',
        height: 'auto',
        disableClose: true,
        data: {
          lenderName: response.lenderName,
          vendorId: response.vendorId,
          borrower: response.partyName,
          loanId: response.loanNumber,
          property: response.property,
          authPnRef: response.authRef,
          refundPnRef: response.pnrefCode,
          refundAmt: response.refundAmount,
          refundRequestId: response.refundRequestId,
          custTrackingNo: response.custTrackingNo
        }
      });
    })
  }

  //cancel refund
  cancelRefund(refundRequestId: any) {
    const dialogRef = this.dialog.open(CancelRefundComponent, {
      maxWidth: 'auto',
      width: '550px',
      height: 'auto',
      disableClose: true,
      data: { refundRequestId: refundRequestId }
    });
  }

  //last 5 payment trans
  public lastFivePayTrans() {
    this.isLoading = true;
    this.dashboardService.getPaymentRequestList('').subscribe((response: any) => {
      console.log('pay trans :', response);
      this.paymentTrans = response;
      this.paymentTransDataSource.data = this.paymentTrans;
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.isLoading = false;
    })
  }

  //received payments
  public recievedPayments() {
    this.isLoading = true;
    this.dashboardService.getRecievedPayments('', this.datePipe.transform(this.lastDay, 'MM-dd-yyyy'), this.datePipe.transform(this.firstDay, 'MM-dd-yyyy'),).subscribe((response: any) => {
      console.log('last settle : ', response);
      this.paymentReceived = response[0].paymentRecievedDetails;
      this.receivedDataSource.data = this.paymentReceived;
      this.paymentReceived = response[0].settledAmount;
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.isLoading = false;
    })
  }

  //pending payments
  public pendingPayments() {
    this.dashboardService.getPendingPayments('', this.datePipe.transform(this.lastDay, 'MM-dd-yyyy'), this.datePipe.transform(this.firstDay, 'MM-dd-yyyy'),).subscribe((response: any) => {
      console.log('Pending settle : ', response);
      this.paymentsPend = response[0].paymentRecievedDetails;
      this.pendingPayDataSource.data = this.paymentsPend;
      this.paymentPending = response[0].settledAmount;
    })
  }

  //pending Remit
  public pendingRemittedPayments() {
    this.dashboardService.getPendingRemittedPayments('', this.datePipe.transform(this.firstDay, 'MM-dd-yyyy'), this.datePipe.transform(this.lastDay, 'MM-dd-yyyy')).subscribe((response: any) => {
      console.log('pending remittance : ', response);
      this.pendingRemittedPay = response[0].paymentRecievedDetails;
      this.pendingRemittedDataSource.data = this.pendingRemittedPay;
      this.remittedPending = response[0].settledAmount;
    })
  }

  //remitted payments
  public remittedPayments() {
    this.isLoading = true;
    this.dashboardService.getRemittedPayments('', this.datePipe.transform(this.lastDay, 'MM-dd-yyyy'), this.datePipe.transform(this.firstDay, 'MM-dd-yyyy')).subscribe((response: any) => {
      console.log('last remitted : ', response);
      this.remittedPay = response[0].paymentRecievedDetails;
      this.remittedDataSource.data = this.remittedPay;
      this.remittedRecieve = response[0].settledAmount;
      this.isLoading = false;
    }, (err) => {
      console.log(err);
      this.isLoading = false;
    })
  }
}
